// extracted by mini-css-extract-plugin
export default {"neutralBtn":"global_neutralBtn__R3bTY","titleCase":"global_titleCase__jNPy9"};